import { useMediaQuery, useTheme } from "@mui/material";
import Fade from "react-reveal/Fade";
// Custom

/*
  This component makes children fade in from bottom when the user reaches
  20% of the children component. On small screen the animation is removed 
  however, since it looks bad and ruins the user experience in my opinion. 
*/
const BottomFade = ({
  fadeOnMobile = false,
  children,
  style = {},
  delay = 0,
  bottom = true,
  left = false,
}) => {
  const theme = useTheme();
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  if (isExtraSmallScreen) {
    if (fadeOnMobile === true) {
      return (
        <Fade style={style} delay={delay} bottom={bottom} left={left}>
          {children}
        </Fade>
      );
    } else {
      return children;
    }
  } else {
    return (
      <Fade style={style} delay={delay} bottom={bottom} left={left}>
        {children}
      </Fade>
    );
  }
};

export default BottomFade;
